<template>
  <div class="payrecord">
    <div class="czjl">充值记录</div>
    <div class="yue-box flex">
      <div>
        <div class="yue">余额</div>
        <div class="last-money">{{ yue }}</div>

        <div class="msg-box-item flex aCenter" style="margin-top: 50px">
          <div class="text">充值金额：</div>
          <el-input
            style="width: 400px; margin-left: 30px"
            v-model="paymuchmoney"
            placeholder="请输入充值金额"
          >
            <i slot="prefix" class="el-input__icon">$</i>
            <i slot="suffix" class="el-input__icon">美元</i>
          </el-input>
        </div>
        <div class="fsyx-btn" style="margin-left: 160px">
          折合人民币：<span
            >￥{{
              (paymuchmoney == "" ? 0.0 : paymuchmoney * huilv).toFixed(2)
            }}</span
          >
        </div>
        <div class="gray-text">当前汇率：1美元={{ huilv }}人民币</div>

        <div class="msg-box-item flex aCenter">
          <div class="flex aCenter">
            <div class="text">手续费：</div>
          </div>
          <el-input
            class="big-input"
            readonly
            style="width: 400px; margin-left: 50px"
            v-model="shouxu"
            :placeholder="'￥' + (paymuchmoney * huilv * 0.01).toFixed(2)"
          >
            <img
              slot="prefix"
              class="litile-img"
              src="../../assets/img/icon_shouxufei.png"
            />
          </el-input>
        </div>
        <div class="gray-text">额外收取充值金额1%的手续费</div>
        <div class="fsyx-btn" style="margin-left: 40px">
          合计金额：<span style="margin-left: 30px"
            >￥{{
              (paymuchmoney == ""
                ? 0.0
                : paymuchmoney * huilv + paymuchmoney * huilv * 0.01
              ).toFixed(2)
            }}</span
          >
        </div>
        <div class="cz-btn" @click="showpaymoney = true">确定</div>
      </div>
      <div class="czbg column aCenter padding-lr">
        <div class="flex">
          <img src="../../assets/img/icon_tip.png" alt="" />
          <div class="black-18-400">充值小提示</div>
        </div>
        <div class="czts gray-16-400" v-html="paytip"></div>
      </div>
    </div>
    <!-- 有记录的时候 -->
    <!-- 价格列表 -->
    <div v-if="paylist.length != 0">
      <div class="list-title flex jBetween">
        <div>用户账号</div>
        <div>公司名称</div>
        <div>充值时间</div>
        <div>充值金额</div>
      </div>
      <div
        v-for="(item, index) in paylist"
        :key="index"
        class="list-con flex jBetween"
      >
        <div>{{ item.user_email }}</div>
        <div>{{ item.user_group }}</div>
        <div>{{ item.pay_time_text }}</div>
        <div>${{ item.money }}元</div>
      </div>
    </div>

    <!-- 没记录的时候 -->
    <!-- <div class="column aCenter" v-else>
      <img src="../../assets/img/bg_jilu.png" alt="" />
      <div class="zwjl">暂无记录</div>
    </div> -->
    <!-- 充值中心 -->
    <div
      class="zhezhao"
      v-show="showpaymoney"
      @click.self="showpaymoney = false"
    >
      <div class="box column jBetween aCenter">
        <img src="../../assets/img/icon_chongzhi.png" alt="" />
        <div class="zccg">充值中心</div>
        <el-input
          readonly
          v-model="paymuchmoney"
          placeholder="请输入充值金额"
        ></el-input>
        <!-- <img
        class="ewm"
        src="../../assets/u=3048242603,4268539918&fm=26&gp=0.jpg"
        alt=""
      /> -->
        <div class="box-item-bor column aCenter jAround">
          <img
            v-if="saomab"
            class="ewm"
            :src="saomaimg"
            alt="正在努力加载中。。。"
          />
          <div class="column aCenter jAround" style="height: 100%" v-else>
            <div class="chose-btn" @click="saoma(2)">支付宝扫码</div>
            <div class="chose-btn" @click="saoma(3)">银联支付</div>
          </div>
        </div>

        <div class="tiaozhuan">请选择支付方式</div>
      </div>
    </div>
    <form
      v-show="false"
      ref="form"
      :action="http_url"
      method="post"
      target="_blank"
    >
      <input
        v-for="(value, name, index) in pay_params"
        :key="index"
        type="text"
        :name="name"
        :value="value"
      />
      <input type="submit" value="submit" />
    </form>
  </div>
</template>

<script>
import Index from "./Index";
import { payListApi, getTipApi } from "../../network/api";
export default {
  name: "Payrecord",
  mixins: [Index],
  created() {
    let formdata = {
      page: 1,
      limit: 1000,
      token: this.$store.state.userinfo.token,
    };
    payListApi(formdata)
      .then((res) => {
        console.log(res);
        this.paylist = res.data.data.list;
        this.yue = res.data.data.user_money;
        this.huilv = res.data.data.huilv;
      })
      .catch();
    getTipApi()
      .then((res) => {
        console.log(res);
        this.paytip = res.data.data.data;
      })
      .catch();
  },
};
</script>
<style scoped src="./Payrecord.css"></style>
